import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UserRightsGetter } from "app/core/api-urls/api-url-setters";
import { firstValueFrom } from "rxjs";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: "root",
})
export class UserRightsService {
  constructor(
    private http: HttpClient,
    private userRightsGetter: UserRightsGetter
  ) {}

  async loadMenuNavigation(obj): Promise<any> {
    const httpUrl = this.userRightsGetter.loadMenuNavigationUrl();
    return await firstValueFrom(this.http.post<any>(httpUrl, obj, httpOptions));
  }
  async assignUserRights(obj): Promise<any> {
    const httpUrl = this.userRightsGetter.assignUserRightsUrl();
    return await firstValueFrom(this.http.post<any>(httpUrl, obj, httpOptions));
  }
  async loadRootLevelMenu(obj): Promise<any> {
    const httpUrl = this.userRightsGetter.loadRootLevelMenuUrl();
    return await firstValueFrom(this.http.post<any>(httpUrl, obj, httpOptions));
  }
  async loadUserRights(obj): Promise<any> {
    const httpUrl = this.userRightsGetter.loadUserRightsUrl();
    return await firstValueFrom(this.http.post<any>(httpUrl, obj, httpOptions));
  }

  async getUserGrid(obj): Promise<any> {
    const httpUrl = this.userRightsGetter.getUserGridUrl();
    return await firstValueFrom(this.http.post<any>(httpUrl, obj, httpOptions));
  }

  async getDropdowns(obj): Promise<any> {
    const httpUrl = this.userRightsGetter.getDropdownsUrl();
    return await firstValueFrom(this.http.post<any>(httpUrl, obj, httpOptions));
  }

}
